import './App.css';
import './Pages/css/main.css'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Header from './Pages/nav/header';
import Footer from './Pages/nav/footer';
import Sidebar from './Pages/nav/sidebar';

import Dashboard from './Pages/dashboard';
import Login from './Pages/login';
import Sugi from './Pages/sugi';
import Paylist from './Pages/paylist';
import Notice from './Pages/notice';
import Settlement from './Pages/settlement';
import CreateMerchant from './Pages/createMerchant';
import Withdraw from './Pages/withdraw';
import CreateMerchantsAgent from './Pages/createMerchantsAgent';
import UrlCreate from './Pages/urlCreate';
import UrlPayment from './Pages/urlPayment';
import UrlHistory from './Pages/urlHistory';
import UrlComplete from './Pages/urlComplete';
import UrlDetail from './Pages/urlDetail';
import UrlUserHistory from './Pages/urlUserHistory';
import UrlNotice from './Pages/urlNotice';

import ErrorBoundary from './Pages/common/ErrorBoundary'
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { change_hostLogoImg } from './store';

function App() {
  console.error = (message) => { };

  let location = useLocation();
  let dispatch = useDispatch();

  useEffect(() => {
    if (window.location.hostname == "cp.onu-terminal.com") {
      dispatch(change_hostLogoImg("onu"))
    }
    else {
      dispatch(change_hostLogoImg("fast"))
    }
  }, [])

  return (
    <div className="App" style={{ maxWidth: "1920px", margin: "0 auto" }}>
      <div className="py-0 md:py-5 header">
        <Header />
        <div className='section1'>
          <Sidebar />
          <div className={`section2 ${location.pathname == '/'
              || location.pathname == '/createMerchantsAgent'
              || location.pathname == '/urlComplete'
              ? "main" : ""}`}>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                {JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                  ?
                  <Route path="/sugi" element={<Sugi />} />
                  : ""}

                {JSON.parse(localStorage.getItem("userId"))?.urlpay == 1
                  ?
                  <>
                    <Route path="/urlCreate" element={<UrlCreate />} />
                    <Route path="/urlHistory" element={<UrlHistory />} />
                  </>
                  : ""}

                {/* <Route path="/sugi" element={<Sugi />} /> */}
                {/* <Route path="/urlCreate" element={<UrlCreate />} /> */}
                {/* <Route path="/urlHistory" element={<UrlHistory />} /> */}

                <Route path="/paylist" element={<Paylist />} />
                <Route path="/notice" element={<Notice />} />
                <Route path="/settlement" element={<Settlement />} />
                <Route path="/withdraw" element={<Withdraw />} />
                <Route path="/createMerchantsAgent" element={<CreateMerchantsAgent />} />
                <Route path="/urlPayment" element={<UrlPayment />} />
                <Route path="/urlComplete" element={<UrlComplete />} />
                <Route path="/urlDetail" element={<UrlDetail />} />
                <Route path="/urlUserHistory" element={<UrlUserHistory />} />
                <Route path="/urlNotice" element={<UrlNotice />} />


                {/* <Route path="/createMerchant" element={<CreateMerchant />} /> */}

                {JSON.parse(localStorage.getItem("userId"))?.sugi_expose == "Y"
                  ?
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                  :
                  <Route path="*" element={<Navigate to="/paylist" />} />
                }
              </Routes>
            </ErrorBoundary>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
